import {Component, OnDestroy, OnInit} from "@angular/core";
import {EntityData, EntityDataStatus} from "@fedeltapointofsale/data-client";
import {Subscription} from "rxjs";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {OutletSalePeriodData} from "../../outlet.data";
import {OutletEntityModel} from "../../outlet-entity.model";
import {SalePeriodSearchModel} from "../../../sale-period/sale-period-search.model";
import {EditMode} from "../../../../framework/entity/edit/edit-page/edit-mode";

@Component({
    selector: "wbo-outlet-edit-sale-periods",
    templateUrl: "./outlet-edit-sale-periods.component.html",
    providers: [SalePeriodSearchModel]
})
export class OutletEditSalePeriodsComponent implements OnInit, OnDestroy {
    EditMode = EditMode;

    outletSalePeriods: OutletSalePeriodData[];

    private subscriptions: Subscription = new Subscription();
    private readySubscription: Subscription;

    constructor(private model: OutletEntityModel, private salePeriodSearchModel: SalePeriodSearchModel, private editService: EditService) {
    }

    private loadData(): void {

        const load = this.model.data.outletSalePeriods;

        this.subscriptions.add(this.salePeriodSearchModel.search().subscribe(() => {
            this.subscriptions.add(this.model.$data.subscribe(() => {
                if (this.readySubscription) {
                    this.readySubscription.unsubscribe();
                }
                if (this.editService.editMode === EditMode.ADD) {
                    this.setOutletSalePeriod();
                } else {
                    this.readySubscription = this.model.$collectionLoaded("outletSalePeriods").subscribe(() => {
                        this.setOutletSalePeriod();
                    });
                }



            }));
        }));
    }

    setOutletSalePeriod(): void {
        this.outletSalePeriods = [];
        this.salePeriodSearchModel.data.forEach((salePeriod: any) => {
            let outletSalePeriod: OutletSalePeriodData = this.model.data.outletSalePeriods.find((osp: OutletSalePeriodData) => osp.salePeriod.id === salePeriod.id);
            if (!outletSalePeriod) {
                outletSalePeriod = <OutletSalePeriodData>EntityData.create(OutletSalePeriodData);
                outletSalePeriod.salePeriod.assign(salePeriod, EntityDataStatus.LOADED);
            }
            this.outletSalePeriods.push(outletSalePeriod);
        });
    }
    saveHandler(outletSalePeriod: OutletSalePeriodData): void {
        const index = this.model.data.outletSalePeriods.findIndex((osp: OutletSalePeriodData) => osp.salePeriod.id === outletSalePeriod.salePeriod.id);
        if (outletSalePeriod.disabled || outletSalePeriod.startTime) {
            if (index === -1) {
                this.model.data.outletSalePeriods.push(outletSalePeriod);
            }
        } else {
            if (index !== -1) {
                this.model.data.outletSalePeriods.splice(index, 1);
            }
        }
    }

    ngOnInit(): void {
        this.loadData();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        if (this.readySubscription) {
            this.readySubscription.unsubscribe();
        }
    }
}
